import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { PhoneInput } from '@alfa-bank/site-input/phone-input-v2';
import { getPhoneCaption as getCaption } from '@alfa-bank/site-dc-form-utils/utils/get-caption';
import { isPhoneError as isError } from '@alfa-bank/site-dc-form-utils/utils/is-error';
import { isSuccess } from '@alfa-bank/site-form-helpers/meta/is-success';
import { Phone as Component } from '@alfa-bank/site-form-phone/src/form-phone';

import type { IDepsCommonPhoneInput, TDcPhoneInput } from './models';

export const CommonPhoneInput = createWidget<IDepsCommonPhoneInput, TDcPhoneInput>({
    Field,
    PhoneInput,
    isSuccess,
    isError,
    getCaption,
})(Component);
